import { format, parseISO, differenceInDays } from "date-fns";
import { es } from "date-fns/locale";

export function fmtDate(iso) {
  if (!iso) return "-";
  try {
    return format(parseISO(iso), "dd-MM-yyyy", { locale: es });
  } catch {
    return iso;
  }
}

export function fmtDateTime(iso) {
  if (!iso) return "-";
  try {
    return format(parseISO(iso), "dd-MM-yyyy HH:mm", { locale: es });
  } catch {
    return iso;
  }
}

export function docStatusFor(expiryISO) {
  if (!expiryISO) return { color: "neutral", label: "Sin fecha", days: null };
  try {
    const days = differenceInDays(parseISO(expiryISO), new Date());
    if (days < 0) return { color: "danger", label: "Vencido", days };
    if (days <= 30) return { color: "warning", label: "Por vencer", days };
    return { color: "success", label: "Vigente", days };
  } catch {
    return { color: "neutral", label: "Sin fecha", days: null };
  }
}

export const ROLE_LABEL = {
  superadmin: "Super Administrador",
  rentacar_admin: "Admin Rent-a-Car",
  workshop_admin: "Admin Taller",
  client_user: "Cliente",
};

export const VEHICLE_STATUS_LABEL = {
  available: "Disponible",
  leased: "Arrendado",
  in_workshop: "En Taller",
  out_of_service: "Fuera de Servicio",
};

export const ORDER_STATUS_LABEL = {
  open: "Abierta",
  in_progress: "En Progreso",
  completed: "Completada",
  cancelled: "Cancelada",
};

export const ORDER_CATEGORY_LABEL = {
  maintenance: "Mantención",
  repair: "Reparación",
  service: "Servicio",
  others: "Otros",
};
